export default [
  {
    path: '/survey/:id',
    name: 'survey',
    component: () => import(/* webpackChunkName: "survey" */ './views/Survey.vue'),
    meta: {
      title: '问卷调研',
      footShow: true,
      headHide: false
    }
  }
];
